var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { Disclosure, Transition } from '@headlessui/react';
import clsx from 'clsx';
import { useBackgroundContext } from '../BackgroundContext/index.js';
import { ChevronDownIcon } from '../icons/index.js';
export const Accordion = (props) => {
    const { as, children, className } = props, rest = __rest(props, ["as", "children", "className"]);
    const Component = as || 'div';
    return (React.createElement(Disclosure, Object.assign({ as: Component, className: clsx('space-y-1', className) }, rest), children));
};
const AccordionButton = (props) => {
    const { children, className } = props, rest = __rest(props, ["children", "className"]);
    const { backgroundType } = useBackgroundContext();
    const hoverClsx = [
        backgroundType === 'main' &&
            'text-basicMain-600 bg-main-50 hover:bg-main-100 hover:text-basicMain-900',
        backgroundType === 'surface' &&
            'text-basicSurface-600 bg-surface-50 hover:bg-surface-100 hover:text-basicSurface-900',
        backgroundType === 'secondary' &&
            'text-basicSecondary-600 bg-actionSecondary-50 hover:bg-actionSecondary-100 hover:text-basicSecondary-200',
    ];
    const iconHoverClsx = [
        backgroundType === 'main' && 'group-hover:text-basicMain-400',
        backgroundType === 'surface' && 'group-hover:text-basicSurface-400',
        backgroundType === 'secondary' && 'group-hover:text-basicSecondary-400',
    ];
    return (React.createElement(Disclosure.Button, Object.assign({ className: clsx(hoverClsx, 'group w-full flex items-center pr-2 py-2 text-left rounded-md', 'focus:outline-none focus-visible:ring', className) }, rest), ({ open }) => (React.createElement(React.Fragment, null,
        React.createElement(ChevronDownIcon, { className: clsx('mr-2 flex-shrink-0 h-5 w-5 transform transition-all ease-in-out duration-150', iconHoverClsx, open ? '' : '-rotate-90') }),
        children))));
};
const AccordionPanel = props => {
    const { children, className } = props, rest = __rest(props, ["children", "className"]);
    const { backgroundClsx, text500Clsx } = useBackgroundContext();
    return (React.createElement(Transition, { enter: "transition duration-100 ease-out", enterFrom: "transform scale-95 opacity-0", enterTo: "transform scale-100 opacity-100", leave: "transition duration-75 ease-out", leaveFrom: "transform scale-100 opacity-100", leaveTo: "transform scale-95 opacity-0" },
        React.createElement(Disclosure.Panel, Object.assign({ className: clsx('w-full flex items-center py-2 text-left rounded-md', 'focus:outline-none focus-visible:ring') }, rest),
            React.createElement("div", { className: clsx(backgroundClsx, text500Clsx, className) }, children))));
};
Accordion.Button = AccordionButton;
Accordion.Panel = AccordionPanel;
//# sourceMappingURL=Accordion.js.map